export default __webpack_public_path__ + "static/media/maintenance.6527e894.svg";